module.exports = __webpack_public_path__ + "static/media/Histogram-of-Sleep.1f653bda.png";